<div class="d-flex gap-2">
    <div class="d-flex align-items-center">
        <label
            [for]="'have-treatment-plan_options_item' + '_yes'"
            class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
        >
            <p-radioButton
                [inputId]="'have-treatment-plan_options_item' + '_yes'"
                [value]="true"
                [ngModel]="value"
                (ngModelChange)="onCheck($event); onTouchedFn?.()"
                name="have-treatment-plan-select"
            />
            <span>有</span>
        </label>
    </div>

    <div class="d-flex align-items-center">
        <label
            [for]="'have-treatment-plan_options_item' + '_no'"
            class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
        >
            <p-radioButton
                [inputId]="'have-treatment-plan_options_item' + '_no'"
                [value]="false"
                [ngModel]="value"
                (ngModelChange)="onCheck($event); onTouchedFn?.()"
                name="have-treatment-plan-select"
            />
            <span>无</span>
        </label>
    </div>

    <div class="d-flex align-items-center">
        <label
            [for]="'have-treatment-plan_options_item' + '_none'"
            class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
        >
            <p-radioButton
                [inputId]="'have-treatment-plan_options_item' + '_none'"
                [value]="null"
                [ngModel]="value"
                (ngModelChange)="onCheck($event); onTouchedFn?.()"
                name="have-treatment-plan-select"
            />
            <span>取消选择</span>
        </label>
    </div>
</div>
